import { userTypes } from 'utils/constants';

// The sidebar groups an operator can reach in the active org: the org has the group's module
// and the user holds its permission, plus the few groups with a rule of their own. The sidebar
// and the landing page after sign-in or an org switch both read this, so the page the user is
// sent to is one the sidebar shows.
export const getAccessibleMenuGroups = ({ menuGroups, activeOrg, permissions, userData }) => {
    const orgModules = activeOrg?.modules || [];

    return menuGroups.filter(item => {
        const defaultCheck = orgModules.includes(item.id) && permissions.includes(item.id);

        const shortTermRentalCheck =
            item.id === 'short_term_rental' &&
            orgModules.includes('short_term_rental') &&
            permissions.includes('rental_manager');

        const devicesForGrantManagersCheck =
            item.id === 'devices' &&
            orgModules.includes('credential_sharing_consumer') &&
            permissions.includes('manage_credential_grants');

        // Manage Reports OR the supervisor type — org-scoped via userData.orgs[orgId].type
        // (activeOrg is the raw org doc and has no `type` field). A supervisor reaches the
        // inbox by virtue of being a supervisor at THIS org, same rule the API's read
        // routes apply.
        const guardReportsCheck =
            item.id === 'guard' &&
            orgModules.includes('guard') &&
            (permissions.includes('manage_reports') ||
                userData?.orgs?.[activeOrg?.org_id]?.type === userTypes.SUPERVISOR);

        const trafficCitationsCheck =
            item.id === 'traffic_citations' &&
            orgModules.includes('traffic_citations') &&
            permissions.includes('manage_traffic_citations');

        return (
            defaultCheck ||
            shortTermRentalCheck ||
            devicesForGrantManagersCheck ||
            guardReportsCheck ||
            trafficCitationsCheck
        );
    });
};

const firstUrlOf = node => {
    if (node?.url) return node.url;

    for (const child of node?.children ?? []) {
        const url = firstUrlOf(child);

        if (url) return url;
    }

    return null;
};

// The first page the sidebar shows for this org, or null when it shows none.
export const getFirstAccessibleUrl = args => {
    for (const group of getAccessibleMenuGroups(args)) {
        const url = firstUrlOf(group);

        if (url) return url;
    }

    return null;
};
